import { useTranslation } from '@lyearn/i18n';
import { SearchFill } from '@lyearn/icons';
import { EmptyState } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';

const NoResultsFound = ({
  searchText,
  setSearchText,
}: {
  searchText?: string;
  setSearchText?: (value: string) => void;
}) => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" className="h-full p-32" direction="col" justifyContent="center">
      <EmptyState
        Icon={SearchFill}
        description={t('Common:EmptyState.NoResultsSearchDescription')}
        primaryAction={{
          label: t('Common:EmptyState.ClearSearch'),
          onClick: () => setSearchText?.(''),
        }}
        title={t('Common:EmptyState.NoResultsSearch', { searchText })}
      />
    </Stack>
  );
};

export default NoResultsFound;
